module.exports = __webpack_public_path__ + "img/rs_whiteL-logo.20207c4.png";